import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import images from '../images';
import { iframeCall } from '../helpers/iframeHelper';
import { trackEvent } from '../helpers/common';

const Container = styled.div`
  z-index: 200;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  padding: 20px;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: white;
  box-shadow: ${({ underline }) => (underline ? '0px 4px 3px -1px rgba(0, 0, 0, 0.05)' : 'none')};
`;

const ExitButton = styled.button`
  border: none;
  background-color: white;
  background-image: url(${images.close});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  margin-left: -5px;
`;

const Header = ({
  headerState,
  setHeaderState
}) => {
  const history = useHistory();

  const goHome = () => {
    iframeCall('clearDeepLink');

    const [, feature, pageOrParam] = history.location.pathname.split('/');
    let event = '';
    switch (feature) {
      case 'blog-article': {
        event = {
          name: 'DZ_BLOG_CLOSE',
          params: { blog_id: pageOrParam }
        };
        break;
      }

      case 'lesson-details': {
        if (pageOrParam === 'rf') event = { name: 'DZ_RF_CLOSE', params: headerState };
        if (pageOrParam === 'mum') event = { name: 'DZ_MM_CLOSE', params: headerState };
        break;
      }

      case 'quiz': {
        if (pageOrParam === 'rf') event = { name: 'DZ_RF_QUIZ_CLOSE', params: headerState };
        if (pageOrParam === 'mum') event = { name: 'DZ_MM_QUIZ_CLOSE', params: headerState };
        break;
      }

      case 'quiz-results': {
        if (pageOrParam === 'rf') event = { name: 'DZ_RF_QUIZ_RESULTS_CLOSE', params: {} };
        if (pageOrParam === 'mum') event = { name: 'DZ_MM_QUIZ_RESULTS_CLOSE', params: {} };
        break;
      }

      case 'quiz-feedback': {
        if (pageOrParam === 'rf') event = { name: 'DZ_RF_QUIZ_FEEDBACK_CLOSE', params: {} };
        if (pageOrParam === 'mum') event = { name: 'DZ_MM_QUIZ_FEEDBACK_CLOSE', params: {} };
        break;
      }

      default:
        break;
    }

    trackEvent(event.name, event.params);
    setHeaderState({});
    history.replace('/landing');
    window.scrollTo(0, 0);
  };

  return (
    <Container underline={history.length > 1 && history.location.pathname !== '/landing'}>
      {
        history.length > 1
          && history.location.pathname !== '/landing'
          ? (
            <ExitButton
              onClick={goHome}
            />
          ) : null
      }
    </Container>
  );
};

export default Header;
